import Splide from '@splidejs/splide';

class GalleryText {
    constructor(root) {
        this.root = root;
        this.mainSlider = root.querySelector('.splide--main');
        this.thumbSlider = root.querySelector('.splide--thumb');

        this.mainSplide = null;
        this.thumbSplide = null;

        this.options = {
            perPage: 1,
            perSlide: 1,
            pagination: false,
            easing: 'ease-in-out',
            speed: 650,
        };

        if (this.mainSlider) this.initMain();
        if (this.thumbSlider) this.initThumb();

        if (!this.mainSlider) return;

        this.mount();
    }

    initMain() {
        const { mainSlider, options } = this;

        const splide = new Splide(mainSlider, {
            arrows: false,
            drag: false,
            type: 'loop',
            autoplay: true,
            interval: 5000,
            ...options,
        });

        this.mainSplide = splide;
    }

    initThumb() {
        const { thumbSlider, options } = this;

        const splide = new Splide(thumbSlider, {
            arrows: true,
            type: 'fade',
            isNavigation: true,
            rewind: true,
            ...options,
        });

        this.thumbSplide = splide;
    }

    mount() {
        if (this.thumbSlider) this.mainSplide.sync(this.thumbSplide);
        this.mainSplide.mount();
        if (this.thumbSlider) this.thumbSplide.mount();
    }
}

const initGalleryTextBlocks = () => {
    const blocks = document.querySelectorAll('.wp-block-gallery-text');

    if (!blocks) return;
    blocks.forEach((block) => {
        new GalleryText(block); // eslint-disable-line
    });
};

export { GalleryText, initGalleryTextBlocks };
